console.log("app.config.js----------------process.env.BUILD_ENV", process.env.BUILD_ENV);
console.log("/////////////////////////////////////////////////////////////");

// let apiDomain = undefined //'https://bytest3.btcchat.io/h5'
// switch (process.env.BUILD_ENV) {
//   case 'dev':
//     apiDomain = 'https://api.btokdev.com/h5'
//     break;
//   case 'test':
//     apiDomain = 'https://bytest3.btcchat.io/h5'
//     break;
//   case 'pre':
//     apiDomain = 'https://api.btokpre.com/h5'
//     break;
//   case 'prod':
//     apiDomain = 'https://api1.sydrd.cn/h5'
//     break;
//   default:
//     break;
// }

const urlMapping = {
  dev: "https://api.btokdev.com/h5",
  test: "https://bytest3.btcchat.io/h5",
  pre: "https://api.btokpre.com/h5",
  prod: "https://api1.sydrd.cn/h5",
};

module.exports = {
  apiDomain: urlMapping[process.env.BUILD_ENV || "prod"],
  /**
   * 本地开发/测试环境改成'test'、生产改成'prod'，原因：
   * 1. 开发命令下没有传递环境参数；
   * 2. 任何启动命令下 serverMiddleware 文件无法读取 process.env.BUILD_ENV，无法获取到 apiDomain；
   */
};



// WEBPACK FOOTER //
// ./app.config.js